var pdfViewerModalTemplate = require('./pdfViewerModalTemplate.hbs');
var PdfViewerWidget = require('./PdfViewerWidget');
var ModalDialogWidget = require('./../modal/ModalDialogWidget');

/**
 * Class for viewing a pdf inside of a modal popup
 *
 * @class PdfViewerModal
 * @constructor
 * @param options {Object}
 * @param options.model {Torso.Model}
 */
module.exports = ModalDialogWidget.extend({
  className: 'brec-dialog brec-pdf-viewer',
  template: pdfViewerModalTemplate,

  injectionSites: {
    'pdf-viewer': '_pdfViewerWidget'
  },

  /**
   * @method initialize
   * @param options
   *   @param options.pdfUrl {String} url of the pdf to view
   *   @param options.isOnTablet {Boolean} true to hide "Open File", "Print", "Download", "View Bookmark" buttons
   * @override
   */
  initialize : function(options) {
    ModalDialogWidget.prototype.initialize.apply(this);
    this._pdfViewerWidget = new PdfViewerWidget({pdfUrl : options.pdfUrl});
  }
});
